import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerMemberRole } from '@vision/ui/interfaces';
import { TicketManagerApiRequest } from '../ticket-manager.api';
import { TicketManagerTeamDeleteArgs } from './teams.api.types';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildGetProjectTeamsRequest = ({ projectId }: { projectId: string }): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/teams`,
});

export const buildCreateTeamRequest = ({
  name,
  projectId,
}: {
  name: string;
  projectId: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/teams`,
});

export const buildUpdateTeamRequest = ({
  name,
  projectId,
  teamId,
}: {
  name: string;
  projectId: string;
  teamId: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/teams/${teamId}/update`,
});

export const buildGetTeamMembersRequest = ({
  projectId,
  teamId,
}: {
  projectId: string;
  teamId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/teams/${teamId}/members`,
});

export const buildAddTeamMemberRequest = ({
  projectId,
  role,
  teamId,
  userId,
}: {
  projectId: string;
  role: TicketManagerMemberRole;
  teamId: string;
  userId: string;
}): TicketManagerApiRequest => ({
  data: {
    role,
    user_id: userId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/teams/${teamId}/add_member`,
});

export const buildRemoveTeamMemberRequest = ({
  projectId,
  teamId,
  userId,
}: {
  projectId: string;
  teamId: string;
  userId: string;
}): TicketManagerApiRequest => ({
  data: {
    user_id: userId,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/teams/${teamId}/remove_member`,
});

export const buildDeleteTeamRequest = ({
  projectId,
  teamId,
}: TicketManagerTeamDeleteArgs): TicketManagerApiRequest => ({
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/teams/${teamId}/delete`,
});
